import React  from "react";
import { observer } from "mobx-react";
import AlertBox from "../../../common/UI/AlertBox/AlertBox";
import "../../../../assets/css/components/Modal/Modal.css";
import "../../../../assets/css/components/Profile/BillingComponent/AddNewCard/AddNewCardComponent.css";
import config from "../../../../config/config";
import Icon from "react-icons-kit";
import { androidClose } from "react-icons-kit/ionicons/androidClose";
import CardForm from "./CardForm";
import {loadStripe} from '@stripe/stripe-js';
import {
  Elements
} from '@stripe/react-stripe-js';


const AddNewCardComponent = (observer((props) => {
  const { modalVisibility, modalLabel, closeModalHandler, modalClass, showPopup } = props
  const stripePromise = loadStripe(config.publisher_key);

  return (
      <AlertBox
        alertVisibility={modalVisibility}
        closeAlertBoxHandler={closeModalHandler}
        backdrop={true}
        alertLabel={modalLabel}
        alertClass={modalClass}
      >
        <div className="modal-wrapper">
          <div className="modal-header">
            <h3>Credit Card Details</h3>
            <span onClick={closeModalHandler} className="close-icon-wrapper">
              <Icon size={24} icon={androidClose} className="cursor-pointer" />
            </span>
          </div>
          <div className="modal-body">
            <Elements stripe={stripePromise}>
              <CardForm
                showPopup={showPopup}
                closeModalHandler={closeModalHandler}
              />
            </Elements>
          </div>
        </div>
      </AlertBox>
  )
}))


export default AddNewCardComponent;



// WEBPACK FOOTER //
// ./src/components/Profile/BillingComponent/AddNewCard/AddNewCardComponent.jsx